import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState } from 'draft-js';
import randomColor from 'randomcolor';
import htmlToDraft from 'html-to-draftjs';
import { _GetSinglePost } from '../../store/actions/blogAction';
import Loading from '../../components/loading/Loading';
import { Error } from '../../components/error/Error';

export const SinglePost = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { loading, singlePost, error } = useSelector((state) => state.blog);

  const color = randomColor({
    count: 10,
    luminosity: 'light',
    hue: 'random',
  });

  useEffect(() => {
    dispatch(_GetSinglePost(id));
  }, [dispatch, id]);

  const IsLoading = () => {
    if (loading) {
      return <Loading />;
    }
  };

  const IsError = () => {
    if (error) {
      return <Error />;
    }
  };

  return (
    <SinglepostWrap>
      {IsLoading()}
      {IsError()}
      {singlePost && Object.entries(singlePost.post).length !== 0 ? (
        <>
          <div className='post__banner container'>
            <img
              className='banner'
              src={singlePost.post.featuredImage}
              alt={singlePost.post.title}
            />
            <div className='fill'>
              <h2>{singlePost.post.title}</h2>
              <p>
                category: <span>{singlePost.post.category}</span>
              </p>
              <p>created {moment(singlePost.post.created).fromNow()}</p>
              <div className='blog__page__content__item__button tags'>
                {singlePost.post.tags.map((ele, index) => {
                  return (
                    <ul key={index}>
                      <li
                        style={{
                          background: `${
                            index === 0
                              ? color[0]
                              : index === 1
                              ? color[3]
                              : index === 2
                              ? color[2]
                              : index === 3
                              ? color[6]
                              : index === 4
                              ? color[9]
                              : color[8]
                          }`,
                        }}
                      >
                        {ele}
                      </li>
                    </ul>
                  );
                })}
              </div>
            </div>
          </div>
          {/* <br /> */}

          <div className='post__content container'>
            <div className='post__content__text'>
              <h2>{singlePost.post.title}</h2>
              <Editor
                editorClassName='blog__page__content__item__text__desc'
                editorState={
                  singlePost.post.content
                    ? EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                          htmlToDraft(singlePost.post.content)
                        )
                      )
                    : EditorState.createEmpty()
                }
                readOnly
                toolbarHidden
              />
            </div>
          </div>
        </>
      ) : (
        <center>
          <p>No Post Found</p>
        </center>
      )}
    </SinglepostWrap>
  );
};

const SinglepostWrap = styled.main`
  padding: 2rem;
  position: relative;
  z-index: 1;
  margin-top: 7rem;

  @media (max-width: 768px) {
    padding: 0;

    .post__banner {
      height: 50vh !important;
    }
  }

  .post__banner {
    height: 70vh;
    border-radius: 10px;
    position: relative;
  }

  .post__banner .banner {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: cover;
  }

  .post__banner .fill {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: 1.5;
  }

  .post__banner .fill h2 {
    font-size: 1.5rem;
    font-weight: 700;
  }

  .post__content {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .tags {
    width: 100%;
    align-self: flex-end;
    position: relative;
  }

  .tags ul {
    display: inline-flex;
    flex-direction: row !important;
    justify-content: flex-start;
    text-align: center;
    text-transform: capitalize;
  }

  .tags ul li {
    margin: 5px;
    padding: 0;
    font-size: 0.7rem;
    font-weight: 700;
    border-radius: 6px;
    padding: 6px 10px;
    list-style: none;
    color: ${({ theme }) => theme.dark};
    box-shadow: 0 5px 15px ${({ theme }) => theme.gradient};
  }

  pre {
    background: ${({ theme }) => theme.pale};
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
